// src/layouts/OperationsLayout.jsx
//
// Layout route for the Operations workspace. Navigation between its views is
// the sidebar's job (the Operations workspace lists them by area), so this
// only provides the outlet; it exists so the section can grow a shared
// header later without touching the routes.

import React from "react";
import { Outlet } from "react-router-dom";
import { Alert, Box } from "@mui/material";
import { useDemo } from "../context/DemoContext";
import { getDemoMarketOperationsDisabledMessage } from "../utils/demoAccess";

export default function OperationsLayout() {
  const { demoProfile, demoError } = useDemo();
  if (!demoProfile && !demoError) return null;
  if (demoError) return <Box sx={{ p: 3 }}><Alert severity="error">Account permissions are unavailable. Please refresh.</Alert></Box>;
  const disabled = getDemoMarketOperationsDisabledMessage(demoProfile);
  if (disabled) return <Box sx={{ p: 3 }}><Alert severity="info">{disabled}</Alert></Box>;
  return <Outlet />;
}
